export default "__VITE_ASSET__1f383cfc__"